// translations.js

export const translations = {
  // Configurações em Inglês
  en: {
    nav: {
      about: "About",
      skills: "Skills",
      projects: "Projects",
      contact: "Contact",
    },
    hero: {
      greeting: "Hi, I'm",
      name: "Felipe Cardoso",
      title: "Full-Stack Developer",
      description:
        "I design and build scalable web applications with a strong focus on architecture, performance, and user experience.",
      resume: "Download Resume",
      viewProjects: "View Projects",
    },
    about: {
      title: "About Me",
      description:
        "Full Stack Developer focused on building scalable and user-centered web applications. I work with React, Node.js, TypeScript, and relational databases, combining clean code, performance, and solid architecture. I have experience working with Docker, automated testing, and REST APIs, and enjoy collaborating in agile environments to deliver reliable and well-structured solutions.",
      highlight1: "Open to Opportunities",
      highlight2: "15+ Projects Completed",
      highlight3: "Full Stack Skills",
    },
    skills: {
      title: "Skills & Technologies",
      frontend: "Frontend",
      backend: "Backend",
      tools: "Tools & Others",
    },
    projects: {
      title: "Featured Projects",
      viewLive: "View Live",
      viewCode: "View Code",
    },
    contact: {
      title: "Get In Touch",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send Message",
      sending: "Sending...",
      success: "Message sent successfully!",
      error: "Failed to send message. Please try again.",
    },
    footer: {
      rights: "All rights reserved.",
      built: "Built with React, JavaScript & FastAPI",
    },
  },

  // Configurações em Português
  pt: {
    nav: {
      about: "Sobre",
      skills: "Habilidades",
      projects: "Projetos",
      contact: "Contato",
    },
    hero: {
      greeting: "Olá, eu sou",
      name: "Felipe Cardoso",
      title: "Desenvolvedor Full-Stack",
      description:
        "Projeto e desenvolvo aplicações web escaláveis com foco em arquitetura, performance e experiência do usuário.",
      resume: "Baixar Currículo",
      viewProjects: "Ver Projetos",
    },
    about: {
      title: "Sobre Mim",
      description:
        "Desenvolvedor Full Stack com foco na construção de aplicações web escaláveis e centradas no usuário. Trabalho com React, Node.js, TypeScript e bancos de dados relacionais, combinando código limpo, performance e arquitetura sólida. Tenho experiência com Docker, testes automatizados e APIs REST, e gosto de atuar em ambientes ágeis para entregar soluções confiáveis e bem estruturadas.",
      highlight1: "Aberto a Oportunidades",
      highlight2: "15+ Projetos Concluídos",
      highlight3: "Full Stack Skills",
    },
    skills: {
      title: "Habilidades & Tecnologias",
      frontend: "Frontend",
      backend: "Backend",
      tools: "Ferramentas & Outros",
    },
    projects: {
      title: "Projetos em Destaque",
      viewLive: "Ver Demo",
      viewCode: "Ver Código",
    },
    contact: {
      title: "Entre em Contato",
      name: "Nome",
      email: "E-mail",
      message: "Mensagem",
      send: "Enviar Mensagem",
      sending: "Enviando...",
      success: "Mensagem enviada com sucesso!",
      error: "Falha ao enviar mensagem. Por favor, tente novamente.",
    },
    footer: {
      rights: "Todos os direitos reservados.",
      built: "Construído com JavaScript, React & FastAPI",
    },
  },
};
